import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { CapturePhoto, MultiCapturePhoto } from '@/components/transport/CapturePhoto';
import { transportApi } from '@/services/transportApi';

/** Attach bill pages (and a missing odometer photo) to an existing fuel / service entry. */
export const AddBillsDialog = ({ row, kind, onClose, onDone }) => {
  const [bills, setBills] = useState([]);
  const [odo, setOdo] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setBills([]); setOdo(null); }, [row]);
  const needOdo = row && !row.odo_photo_url;

  const save = async () => {
    if (!bills.length && !odo) { toast.error('Take at least one photo'); return; }
    setBusy(true);
    try {
      const fn = kind === 'fuel' ? transportApi.addFuelPhotos : transportApi.addServicePhotos;
      await fn(row.id, { bill_photos: bills, odo_photo: odo || undefined });
      toast.success('Photos added'); onDone?.(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not save the photos — try again'); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid={`${kind}-add-bills-dialog`} className="max-h-[calc(100dvh-6rem)] sm:max-h-[92dvh] overflow-y-auto overflow-x-hidden overscroll-contain w-[calc(100vw-1rem)] sm:w-full rounded-lg p-4 sm:p-6">
        <DialogHeader>
          <DialogTitle>Add bill photos</DialogTitle>
          <DialogDescription>{row?.date} · {row?.vehicle_label} · ₹{kind === 'fuel' ? row?.amount : row?.cost}{row?.bill_photo_urls?.length ? ` · ${row.bill_photo_urls.length} bill(s) already attached` : ''}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 min-w-0">
          <div><Label>Bill pages</Label><MultiCapturePhoto label="Photograph the bill" photos={bills} onChange={setBills} testId={`${kind}-add-bills-photos`} /></div>
          {needOdo && <div><Label>Odometer photo (missing)</Label><CapturePhoto label="Photograph odometer" onCapture={setOdo} captured={!!odo} testId={`${kind}-add-odo-photo`} /></div>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={save} disabled={busy} data-testid={`${kind}-add-bills-save`}>{busy ? 'Saving…' : 'Save photos'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddBillsDialog;
